import { useHotkeys } from "react-hotkeys-hook";

interface UseSaveHotkeyOptions {
  enabled: boolean;
  canSave: boolean;
  onSave: () => void | Promise<void>;
}

export const useSaveHotkey = ({
  enabled,
  canSave,
  onSave,
}: UseSaveHotkeyOptions) => {
  useHotkeys(
    "mod+enter",
    () => {
      if (!enabled || !canSave) return;
      void onSave();
    },
    {
      enabled,
      preventDefault: true,
      enableOnFormTags: true,
    },
    [enabled, canSave, onSave]
  );
};
